import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const TotalContainer = styled.div`
  height: 44px;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: 0px ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  background-color: ${props => props.theme.colors.info.surface};
`

export const CostsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  margin-top: ${props => props.theme.spacing.sp16};
`

export const CostLine = styled.div`
  display: flex;
  justify-content: space-between;
`
